var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "P4L full logo (1) 1",
    clipPath: "url(#clip0_4388_20111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2669 0H23.0355V15.1362H26.9625V22.7242H22.995V31.2408H9.27073C13.4554 26.4833 15.2758 21.9608 16.1123 19.2932C17.4622 14.9897 17.692 10.9165 17.8124 8.78856C17.9309 6.69197 17.9019 4.924 17.8463 3.63904C17.392 5.88999 16.1274 10.577 12.2663 15.0548C7.85791 20.167 2.60216 22.0646 0.404297 22.7236C0.633518 20.6385 0.863344 18.5528 1.09256 16.4676C2.69288 15.785 5.79008 14.204 8.37986 10.8978C11.8684 6.44474 12.221 1.68776 12.2669 0Z",
    fill: "#1881C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.75307 9.43126C4.27355 9.43126 5.50614 8.20237 5.50614 6.68645C5.50614 5.17054 4.27355 3.94165 2.75307 3.94165C1.23259 3.94165 0 5.17054 0 6.68645C0 8.20237 1.23259 9.43126 2.75307 9.43126Z",
    fill: "#1881C5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4388_20111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.33770fcd3ecec4429a010962b9bef9ff.svg";
export { ForwardRef as ReactComponent };